import { render, staticRenderFns } from "./AdditionalData.vue?vue&type=template&id=2354867c&"
import script from "./AdditionalData.vue?vue&type=script&lang=ts&"
export * from "./AdditionalData.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalData.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports